/**
 * 是否是分享报告
 * @param $route
 * @returns {*|boolean}
 */
export function isInShare($route){
  return $route.matched[0] && $route.matched[0].name == 'share'
}
